module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "uploadExcel"
  }, [_c('el-button', {
    attrs: {
      "type": "warning",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.toImportExcel
    }
  }, [_vm._v(_vm._s(_vm.$t('other.importExcel')))]), _vm._v(" "), _c('input', {
    staticClass: "c-hide",
    attrs: {
      "id": "excel-upload-input",
      "type": "file",
      "accept": ".xlsx, .xls"
    },
    on: {
      "change": _vm.handkeFileChange
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-88a3c5a6","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/uploadExcel.vue
// module id = 1181
// module chunks = 1